import {
  MensagemItem,
  MensagemOrigem,
  MensagemFiltro,
} from "features/mensagens/typings";
import HeaderTable from "./components/HeaderTable";
import CollapseMensagemItem from "./components/CollapseMensagemItem";
import CardDefault from "components/Cards/CardDefault/index";
import { Box, Skeleton } from "@chakra-ui/react";
import { Empty } from "antd";
import { TipoDestinoEnum } from "core/features/documentos/enums";

interface MensagensTableProps {
  data: MensagemItem[];
  searchValue: string;
  onSearch: (q?: string) => any;
  mensagensRespondidas?: boolean;
  onSelectMensagensRespondidas?: (type?: boolean) => any;
  isLoading?: boolean;
  onDelete: (id: string) => any;
  onArquivar: (id: string) => any;
  origem: MensagemOrigem;
  date?: { dataInicio?: string; dataFim?: string };
  onChangeOrder: (
    changeValue: "orderBy" | "orderDirection",
    value?: "ASC" | "DESC" | string
  ) => void;
  onSearchPortaria: (type: boolean) => any;
  isPortaria: boolean;
  destino?: TipoDestinoEnum;
  filtro?: MensagemFiltro;
  setIsOpenModalFiltros: (v: boolean) => void;
}

function MensagensTable({
  data,
  searchValue,
  onSearch,
  mensagensRespondidas,
  onSelectMensagensRespondidas,
  isLoading,
  onDelete,
  onArquivar,
  origem,
  onChangeOrder,
  date,
  isPortaria,
  onSearchPortaria,
  destino,
  filtro,
  setIsOpenModalFiltros,
}: MensagensTableProps) {
  const showTag = origem === MensagemOrigem.Recebida;

  return (
    <>
      <CardDefault>
        <Box mb={4}>
          <HeaderTable
            onSelectPortaria={onSearchPortaria}
            isPortaria={isPortaria}
            onChangeOrder={onChangeOrder}
            date={date}
            value={searchValue}
            onSearch={onSearch}
            mensagensRespondidas={mensagensRespondidas}
            onSelectMensagensRespondidas={onSelectMensagensRespondidas}
            showTag={showTag}
            destino={destino}
            origem={origem}
            orderBy={filtro?.orderBy}
            orderDirection={filtro?.orderDirection}
            setIsOpenModalFiltros={setIsOpenModalFiltros}
          />
        </Box>

        {isLoading ? (
          <Box>
            <Skeleton mb={2} h="87px" flex={1} w="100%" rounded={15} />
            <Skeleton mb={2} h="87px" flex={1} w="100%" rounded={15} />
            <Skeleton mb={2} h="87px" flex={1} w="100%" rounded={15} />
            <Skeleton mb={2} h="87px" flex={1} w="100%" rounded={15} />
          </Box>
        ) : null}
        {!isLoading && !data.length ? (
          <Empty
            description={`Sem mensagens ${
              origem === MensagemOrigem.Recebida
                ? "recebidas"
                : origem === MensagemOrigem.Arquivada
                ? "arquivadas"
                : origem === MensagemOrigem.Excluida
                ? "excluídas"
                : "enviadas"
            } `}
          />
        ) : null}

        {data.map((item) => (
          <CollapseMensagemItem
            key={item.id}
            onArquivar={onArquivar}
            onDelete={onDelete}
            item={item}
            showTag={showTag}
            origem={origem}
          />
        ))}
      </CardDefault>
    </>
  );
}

export default MensagensTable;
